import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {EformService} from "../../../service/eform.service";

@Component({
   selector: 'app-email',
   templateUrl: './email.component.html',
   styleUrls: ['./email.component.css']
})
export class EmailComponent implements OnInit{
   @Input() field: any = {};
   @Input() form: FormGroup;
   @Input() checkValidate: any;
   @Input() fieldName: any;
   @Input() placeholder: any;
   @Input() labelName: any;
   @Input() hideHeader: boolean = false;
   value: any;
   constructor(private eformService: EformService) {
   }

   ngOnInit(): void {
      this.value = this.eformService.eForm.value.value && this.eformService.eForm.value.value[this.fieldName] ? this.eformService.eForm.value.value[this.fieldName] : this.value;
   }

   isEmpty(value: any): boolean {
      return value == null || value === '';
   }
}
